export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
export const UNO_APPLICATION_ID = "5a9af8cd-2890-4637-b4f2-70641a759a9b";
export const applicationId = "e28adc3f-938b-416a-9155-a5942d84f1b0";

// export const UNO_URL = 'http://localhost:3003';
export const UNO_URL = "https://api.simulanis.io";
// export const UNO_URL = 'https://simulanis-uno-backend-backup-uat.azurewebsites.net';

export const SECRET_KEY = "uxbA5VlmZ=dcdzMk^%gIw?&N<P";

// export const SSO_URL = "https://sso.simulanis-legacy-simulanis-legacy-uat.azurewebsites.net";
export const SSO_URL = "https://sso.simulanis.io";
// export const SSO_URL = "http://localhost:5000";

export const CHANNEL_ID = "ac1765fe-cd99-46ee-a567-f747f4f3c61f";

export const moduleFilterId = 1;
export const applicationCategoryId = 8;
export const environmentFilterId = 88;
